<template>
  <div class="wrapper my-8 mx-8 d-flex flex-column align-center justify-center">
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between align-center" style="width:100%">
          <h3>Live data</h3>
          <v-btn text color="rgb(0,170,221)" @click="getData">Refresh</v-btn>
        </div>
      </v-card-title>
      <v-card-text>
        <v-data-table
          disable-sort
          hide-default-footer
          :headers="headers"
          :items="data"
          :loading="loading"
        ></v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.data.pop();
      this.loading = true;
      axios
        .get(`${process.env.VUE_APP_BASE_URL}admin/currentActivity`)
        .then(res => {
          console.log(res)
          this.data.push(res.data);
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      headers: [
        {
          text: "Active Calls",
          value: "activeCallsNum"
        },
        {
          text: "Available doctors",
          value: "availableDoctorsNum"
        },
        {
          text: "Visible doctors",
          value: "visibleDoctorsNum"
        },
        {
          text: "Logged in patients",
          value: "loggedInTravellersNum"
        },
        {
          text: "Active patients",
          value: "activeTravellersNum"
        },
        {
          text: 'iOS logged-in travellers',
          value: 'iosLoggedInTravellerCount'
        },
        {
          text: 'android logged-in travellers',
          value: 'androidLoggedInTravellerCount'
        },
        {
          text: 'web logged-in travellers',
          value: 'webLoggedInTravellerCount'
        },
        {
          text: 'iOS visible doctors',
          value: 'iosVisibleDoctorCount'
        },
        {
          text: 'android visible doctors',
          value: 'androidVisibleDoctorCount'
        },
        {
          text: 'web visible doctors',
          value: 'webVisibleDoctorCount'
        }
      ]
    };
  }
};
</script>
